// redux

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../config/api";
import config from "../config/config";
import { getCurrentLoggedInSessionTokenWithPromise } from "../config/userPool";

const { DEPOT_ENDPOINT,DEPOT_BY_DIVISION } = config.api_endpoint;

const initialState = {
  loading: false,
  depot_ids: [],
  error: null,
};

export const fetchAllDepot = createAsyncThunk(
  "depot/fetchAllDepot",
  async (_, { rejectWithValue }) => {
    try {
      const token = await getCurrentLoggedInSessionTokenWithPromise();
      const results = await api.get(DEPOT_ENDPOINT, {}, token);
      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);

export const fetchDepotByDivisions = createAsyncThunk(
  "depot/fetchDepotByDivisions",
  async ({ data }, { rejectWithValue }) => {
    try {
      console.log(data);
      const token = await getCurrentLoggedInSessionTokenWithPromise();
      const res = await api.post(
        `${DEPOT_BY_DIVISION}`,
        JSON.stringify(data),
        token
      );
      return res.data;
    } catch (error) {
      console.log("error: ", error);
      return rejectWithValue(error.details);
    }
  }
);

const DepotSlice = createSlice({
  name: "depot",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllDepot.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllDepot.fulfilled, (state, action) => {
        // console.log(action);
        state.loading = false;
        state.depot_ids = action.payload;
      })
      .addCase(fetchAllDepot.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchDepotByDivisions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDepotByDivisions.fulfilled, (state, action) => {
        // console.log(action);
        state.loading = false;
        state.depot_ids = action.payload;
      })
      .addCase(fetchDepotByDivisions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });      
  },
});

const DepotReducer = DepotSlice.reducer;
export default DepotReducer;
